export const fitMinMaxSize = (value, min, max) => {
  const safeMax = Math.max(max, 0),
        safeMin = Math.min(min, safeMax)

  return Math.min(Math.max(value, safeMin), safeMax)
}

export const getContentSize = formNode => Array.from(formNode.children).reduce((acc, child) => {
  acc.height = Math.max(acc.height, child.offsetTop + child.offsetHeight)
  acc.width = Math.max(acc.width, child.offsetLeft + child.offsetWidth)
  return acc
}, { height: 0, width: 0 })

export const getResizedPanelState = ({ direction, event, maxHeight, maxWidth, minHeight, minWidth, start }) => {
  const deltaX = event.clientX - start.pointer.x,
        deltaY = event.clientY - start.pointer.y,
        isRightHandle = direction.includes("right"),
        isTopHandle = direction.includes("top"),
        unclampedWidth = isRightHandle ? start.size.width + deltaX : start.size.width - deltaX,
        unclampedHeight = isTopHandle ? start.size.height - deltaY : start.size.height + deltaY,
        width = fitMinMaxSize(unclampedWidth, minWidth, maxWidth),
        height = fitMinMaxSize(unclampedHeight, minHeight, maxHeight)

  return {
    height,
    width,
    x: isRightHandle ? start.position.x + (width - start.size.width) : start.position.x,
    y: isTopHandle ? start.position.y + (start.size.height - height) : start.position.y
  }
}

export const suppressTextSelection = () => {
  const previousUserSelect = document.body.style.userSelect

  document.body.style.userSelect = "none"
  return () => {
    document.body.style.userSelect = previousUserSelect
  }
}
